<template>
  <v-app id="improve">
    <router-view />
    <vue-snotify></vue-snotify>
    <CookieBanner />
  </v-app>
</template>

<script>
import CookieBanner from "@/components/CookieBanner.vue";

export default {
  name: "App",
  components: {
    CookieBanner
  },
  data () {
    return {
      timeoutID: ''
    }
  },
  methods: {
    setup() {
      document.addEventListener("mousemove", this.resetTimer, false);
      document.addEventListener("mousedown", this.resetTimer, false);
      document.addEventListener("keypress", this.resetTimer, false);
      document.addEventListener("DOMMouseScroll", this.resetTimer, false);
      document.addEventListener("mousewheel", this.resetTimer, false);
      document.addEventListener("touchmove", this.resetTimer, false);
      document.addEventListener("MSPointerMove", this.resetTimer, false);
    },
    resetTimer() {
      window.clearTimeout(this.timeoutID);
    },
  },
  created () {
    this.setup()
  }
};
</script>
